module.exports = __webpack_public_path__ + "img/202504_09.93fda97e.jpg";